import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import List from '@material-ui/core/List';
import Collapse from '@material-ui/core/Collapse';
import { actionDockSetExpandLeadsStatuses } from '@/modules/application/actions/dock';
import Expand from './Expand';
import ListItem from './ListItem';


const LeadsStatuses = (props) => {
    return (
        <>
            <ListItem title="Статусы" to="/leads_statuses/"
                      onClick={(event) => {
                          event.preventDefault();
                          props.setExpand(!props.expand);
                      }}
            >
                <Expand expand={props.expand} setExpand={props.setExpand}/>
            </ListItem>
            <Collapse in={props.expand}>
                <List disablePadding={true}>
                    <ListItem title="База данных" to="/leads_statuses/db/"/>
                </List>
                <List disablePadding={true}>
                    <ListItem title="Выгрузка" to="/leads_statuses/fetch/"/>
                </List>
            </Collapse>
        </>
    );
};

export default connect(
    (state) => ({
        expand: state.dock.expandLeadsStatuses,
    }),
    (dispatch) => ({
        setExpand: bindActionCreators(actionDockSetExpandLeadsStatuses, dispatch),
    })
)(LeadsStatuses);
